import { createSlice } from "@reduxjs/toolkit";
import { getTags } from "../../reduxApi/admin/TagReduxApi";
const TagSlice = createSlice({
  name: "tags",
  initialState: {
    status: "idle",
    tags: [],
  },
  reducers: {
    // deleteOrdersAction: (state, action) => {
    //     // action.payload.forEach((id) => {
    //     //     const index = state.orders.findIndex((item) => item.orders.ROWID === id);
    //     //     if (index !== -1) {
    //     //         state.orders.splice(index, 1);
    //     //     }
    //     // });
    //     state.orders = state.orders.filter(item => !action.payload.includes(item?.orders?.ROWID));
    // },
    // updateOrdersAction: (state, action) => {
    //     // console.log("action", action.payload)
    //     const index = state.orders.findIndex((item) => item.orders.ROWID === action.payload.ROWID)
    //     if (index != -1) {
    //         state.orders.splice(index, 1, { orders: action.payload })
    //     }
    // },
    // addTagsAction: (state, action) => {
    //     // console.log("Adding client:", action.payload);
    //     const temp = action.payload.formData;
    //     temp.ROWID = action.payload.ROWID
    //     state.tags.unshift({ tags: temp });
    // }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTags.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getTags.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.tags = action.payload.data;
      });
  },
});
export const { addTagsAction } = TagSlice.actions;
export default TagSlice.reducer;
